import React, { useState, useEffect } from 'react';
import NavigationBar from '../../ReusableComp/NavigationBar';
import NavBarLeft from '../../ReusableComp/NavBarLeft';
import { useDispatch, useSelector } from 'react-redux';
import { getZoneData, getStudyData, getZoneCounts} from '../../../Redux/actions/actions';
import axios from "../../../axios-interceptor";
import { base_url } from "../../../utilities";
import PopUpModal from "../../ReusableComp/PopUpModal";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';
import { useNavigate } from 'react-router';
import Loader from '../../ReusableComp/Loader';

const PMSAdminAddMarketingHead = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (!localStorage.getItem("login_user_name")) {
            navigate("/");
        }
    }, []);
    const dispatch = useDispatch();
    const [open, setOpen] = React.useState(false);
    const zoneData = useSelector((state) => state.data);
    const studyData = useSelector((state) => (state.studyData));
    const zoneCounts = useSelector((state) => (state.zoneCounts));
    const [zone, setZone] = useState('');
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [zoneName, setZoneName] = useState("")
    const [studyIds, setStudyIds] = useState([]);
    const [studyInfo, setStudyInfo] = useState([]);
    const [loading, setLoading] = useState(false);



    useEffect(() => {
        dispatch(getZoneData());
        dispatch(getStudyData());
    }, [dispatch]);
    const sampar = [];

    const handleChange = (selected) => {
        selected.map((item) => { sampar.push(item.value.study_id) })
        setSelectedOptions(selected);
        setStudyIds(sampar);
        const filteredJsonList = studyData.filter((json) => sampar.includes(json.study_id));
        setStudyInfo(filteredJsonList)
    };


    const handleClosePopup = () => {
        setOpen(false);
        window.location.reload();
    };


    const createNewPI = () => {
        let marketing_head_object = {
            name: mrName,
            email: mrEmail,
            study_id: studyIds,
            zone_id: zone,
            bbil_employee_id: bbilEmployeeId
        };
        setLoading(true);
        axios
            .post(base_url + "marketing-head/create_marketing_head", marketing_head_object)
            .then((res) => {
                
                 setLoading(false);
             
               
                if (res.data.data.errors) {
                    if (res.data.data.errors[0].message === "email must be unique") {
                        toast.error('The user has already been created with the given email.', {
                            toastId: 1
                        })
                    }
                }
                else {
                    setOpen(true);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const [mrName, setmarketingHeadName] = useState("");
    const handlemarketingHeadNameChange = (event) => {
        const inputValue = event.target.value;
        const regex = /^[A-Za-z\s.]+$/;

        if (regex.test(inputValue) || inputValue === '') {
            setmarketingHeadName(event.target.value);
        }
    };
    const [mrEmail, setmarketingHeadEmail] = useState("");
    const handlemarketingHeadEmailChange = (event) => {
        const input = event.target;
        const isValid = input.checkValidity();
        setIsPiEmailValid(isValid);
        setmarketingHeadEmail(input.value);

    };

    const viewProfile = () => {
        window.location.replace("/pmsadminmarketingheadlist")
    }
    const selectZone = (event) => {
        if(event.target.value === ""){
            setZone("")
            setZoneName("")
        }
        else{
            const selectedIndex = event.target.selectedIndex;
            setZone(event.target.value)
            setZoneName(event.target.options[selectedIndex].text)
            dispatch(getZoneCounts({zone_id:event.target.value}));
        }
        
    }

    const [regStep, setRegStep] = useState(1);

    const registrationSteps = [
        {
            stepTitle: "1. Marketing Head Details",
            description: "Name, Email & ID"
        },
        {
            stepTitle: "2. Study Details",
            description: "Study Information"
        },
        {
            stepTitle: "3. Zone Information",
            description: "Zone, state, city sites"
        },
        {
            stepTitle: "4. Preview and Confirm",
            description: "Final confirmation"
        },

    ];

    const handleStepChange = (val) => {
        if (val > 0 && regStep < 4) {
            let shift = regStep + val
            setRegStep(shift);
        }
        if (val < 0 && regStep > 1) {
            let shift = regStep + val
            setRegStep(shift);
        }

    }
    const [ispiEmailValid, setIsPiEmailValid] = useState(true)

    function handleBlur(){
        setIsPiEmailValid(validateEmail(mrEmail));
    }
    const validateEmail = (email) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        return regex.test(email);
      };
    const [bbilEmployeeId, setBbilEmployeeId] = useState("");
    const handlePmarketingHeadMrcNumberChange = (event) => {
        setBbilEmployeeId(event.target.value);
    };

    function convertToTitleCase(str) {
        return str.replace(/\w\S*/g, function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    }
    const customDropdownIndicator = () => null;
    return (
        <>
        <div>
            <NavigationBar  studyDropdwn={true} title={"Marketing Head"} />
            <div className='main_body registration_steps_main'>
                <div className='row flex-nowrap'>
                    <div className="col-lg-3 pi_left_content_main" >
                        <div className='lableSteps'>
                            <span >Registration Steps</span>
                        </div>

                        <div className='pmsaddpireg'>
                            {registrationSteps?.map((step, index) => {
                                return (
                                    <div className={`my-div ${regStep === index + 1 ? 'registration_steps_selected' : 'registration_steps'}`} key={index}>
                                        <span>{step.stepTitle}</span>
                                        <span className='registration_description'>{step.description}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="col">
                        <div className='lableContent'>
                            <span >{registrationSteps[regStep - 1].stepTitle}</span>
                            <span >{regStep} of 4</span>
                        </div>

                        {/* PI Details inputs */}
                        {regStep === 1 &&
                            <div className='med_rev_1st'>
                                <div className='piDetilsRow'>
                                    <div className='piDetilsItems'>
                                        <label htmlFor="mrName">Name<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            value={mrName}
                                            className="customInput"
                                            id='mrName'
                                            type='text'
                                            placeholder='Full Name'
                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px", width: "380px" }}
                                        onChange={handlemarketingHeadNameChange}
                                        />
                                    </div>
                               <div className='piDetilsItems '>
                                        <label htmlFor="piEmail">Email<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            className="customInput"
                                            value={mrEmail}
                                            id='piEmail'
                                            type='email'
                                            name='piEmail'
                                            placeholder='email@gmail.com'
                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px", width: "380px" }}
                                            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                            required
                                            onChange={handlemarketingHeadEmailChange}
                                        />
                                        {!ispiEmailValid && <p className='errormsg' >Invalid email format</p>}
                                    </div>


                                </div>

                                <div className='piDetilsRow'>
                                    <div className='piDetilsItems'>
                                        <label htmlFor="bbilEmployeeId">BBIL Employee Id <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            value={bbilEmployeeId}
                                            className="customInput"
                                            id='bbilEmployeeId'
                                            type='text'
                                            placeholder='Enter Here'
                                            aria-placeholder='#D4D4D4'
                                            style={{ padding: "16px 12px", width: "380px" }}
                                            onChange={handlePmarketingHeadMrcNumberChange}
                                        />
                                    </div>

                                </div>

                            </div>
                        }
                        {/* Study and Dose Details */}
                        {regStep === 2 &&
                            <div className='piRegPrev'>
                                <div style={{ margin: '32px', display: "flex", flexDirection: "column", textAlign: "start" }}>
                                    <label htmlFor="piStudy">Select Study<span className="text-danger">*</span></label>
                                   
                                    <Select
                                        id="piStudy"
                                        isMulti
                                        options={studyData?.map((item) => ({
                                            value: item,
                                            label: `${item.study_name}`,
                                            // label: item.study_name.length > 120 ? `${item.study_name.substring(0, 120)}...` : item.study_name,
                                        }))}
                                        value={selectedOptions}
                                        onChange={handleChange}
                                        className='custom_select_main'
                                        placeholder="Select Study from the options"
                                        styles={{
                                            control: (provided, state) => ({
                                              ...provided,
                                             margin: 'auto',
                                              paddingRight:"25px" 
                                            }),
                                           }}
                                       components={{
                                            IndicatorSeparator: () => null, 
                                         DropdownIndicator: customDropdownIndicator,
                                         ClearIndicator: () => null,
                                            
                                     }}
                                    />
                                   
                                </div>
                            </div>
                        }
                        {/* Site Information */}
                        {regStep === 3 &&
                            <div className='piRegPrev'>
                                <div className='siteInformationRows'>
                                    <div className='selectZoneDsplay'>
                                        <label htmlFor="piStudy">Select Zone<span style={{ color: "red" }}>*</span></label>
                                        <div className='custom_select_main'>
                                        <select id='piStudy' className='selectTag' value={zone} style={{ width: "66vw" }} onChange={selectZone}>
                                            <option value={""}>Please select Zone</option>
                                            {zoneData && zoneData?.map((zone) =>
                                                <option value={zone.zone_id}>{zone.zone_name}</option>
                                            )}
                                        </select>
                                        </div>
                                       
                                    </div>
                                </div>
                                {zoneName !== "" && zoneCounts ?
                                <div className='zoneInformationRows'>
                                    <div className='rightSide' style={{width:"100%"}}>
                                        <h6>Zone</h6>
                                        <p>{zoneCounts.zone_name}</p>
                                        <div className='zoneCard' style={{width:"100%"}}>
                                            <div style={{display:"flex", flexDirection:"row", justifyContent:"space-between"}}>
                                                
                                                    <h6>{zoneCounts.stateCount}</h6>
                                                
                                                    <img src="./images/icons/pointer.svg" alt="" />
                                                
                                            </div>
                                            <div style={{textAlign:"start"}}>
                                            States
                                            </div>
                                        </div>

                                        <div className='zoneCard' style={{width:"100%"}}>
                                            <div style={{display:"flex", flexDirection:"row", justifyContent:"space-between"}}>
                                                
                                                    <h6>{zoneCounts.cityCount}</h6>
                                                
                                                    <img src="./images/icons/pointer.svg" alt="" />
                                                
                                            </div>
                                            <div style={{textAlign:"start"}}>
                                            Cities
                                            </div>
                                        </div>

                                        <div className='zoneCard' style={{width:"100%"}}>
                                            <div style={{display:"flex", flexDirection:"row", justifyContent:"space-between"}}>
                                                
                                                    <h6>{zoneCounts.siteCount}</h6>
                                                
                                                    <img src="./images/icons/pointer.svg" alt="" />
                                                
                                            </div>
                                            <div style={{textAlign:"start"}}>
                                            Sites
                                            </div>
                                        </div>
                                        

                                    </div>
                                </div>
                                :
                                null
                                }
                            </div>

                        }

                        {regStep === 4 &&
                            <div className='piRegPrev'>
                                <div style={{ margin: "24px 32px" }}>
                                    <p style={{ fontWeight: "bold", color: "black" }}>Name: {mrName}</p>

                                </div>
                                <div style={{ border: "1px dotted #E1E5E7", marginLeft: "32px", marginRight: "24px" }}></div>
                                <div style={{ display: "flex", flexDirection: "row", margin: "24px 32px 0px 32px", justifyContent: "space-evenly" }}>
                                
                                    <p>
                                        {mrEmail}
                                        <img style={{ height: "20px", margin: "5px" }} src="./images/icons/Mail Send Envelope by Streamlinehqmainemail.svg" alt="" />
                                    </p>
                                    <p>.</p>
                                    <p>ID: {bbilEmployeeId}</p>

                                </div>

                                <div style={{ border: "1px dotted #E1E5E7", marginLeft: "32px", marginRight: "32px" }}></div>
                                {studyInfo?.map((item) => {
                                    return(
                                        <div className='zoneInformationRows'>
                                            <div className='leftSide'>
                                                <h6>{item.study_name} </h6>
                                                <div className='horizontalLine'></div>
                                                <h6>No. of Doses: {item.number_of_doses}</h6>
                                                <div className='horizontalLine'></div>
                                                {/* <div style={{display:"flex", flex:"row", justifyContent:"space-between", alignItems:"center", width:"400px"}}>
                                                    <p>South Zone</p>
                                                    <img src="./images/icons/location.svg" alt="loc"/>
                                                </div> */}
                                                <p>Product Name: {item.product_name}</p>
                                                <p>Age Group: {item.age_group}</p>
                                            </div>
                                            <div className='rightSide'>
                                                    <div className='zoneCard'>
                                                        <div style={{display:"flex", flexDirection:"row", justifyContent:"space-between"}}>
                                                                <h6>{item.date_of_approval}</h6>
                                                                <img src="./images/icons/startsCalender.svg" alt="" />
                                                        </div>
                                                        <div style={{textAlign:"start"}}>
                                                            Date of approval
                                                        </div>
                                                    </div>
                                                    <div className='zoneCard'>
                                                        <div style={{display:"flex", flexDirection:"row", justifyContent:"space-between"}}>
                                                                <h6>{item.estimated_sites}</h6>
                                                                <img src="./images/icons/pointer.svg" alt="" />
                                                        </div>
                                                        <div style={{textAlign:"start"}}>
                                                            Estimated sites
                                                        </div>
                                                    </div>
                                                    <div className='zoneCard'>
                                                        <div style={{display:"flex", flexDirection:"row", justifyContent:"space-between"}}>
                                                                <h6>{item.estimated_subjects}</h6>
                                                                <img src="./images/icons/pointer.svg" alt="" />
                                                        </div>
                                                        <div style={{textAlign:"start"}}>
                                                            Estimated subjects
                                                        </div>
                                                    </div>
                                                

                                            </div>
                                        </div>
                                    )
                                })}
                                

                                
                            </div>

                        }



                        <div className='registrationStepsFooter'>
                            {regStep > 1 &&
                                <button className="white_btn" onClick={() => handleStepChange(-1)} >Previous</button>
                            }
                            {regStep === 1 &&
                             <div className='d-flex '>
                             <button className="white_btn white_btn_back me-3" onClick={() => navigate("/pmsadminmarketingheadlist")} >Back</button>
                                 <button className="orange_btn" onClick={() => handleStepChange(1)}
                                 disabled={!(mrName !== "" && bbilEmployeeId !== "" &&
                                 mrEmail !== "" && ispiEmailValid)}
                             >Continue</button>
                            </div>

                            }
                            {regStep === 2 &&
                                <button className="orange_btn" onClick={() => handleStepChange(1)}
                                disabled={!(selectedOptions.length !== 0)}
                                >Continue</button>
                            }
                            {regStep === 3 &&
                                <button className="orange_btn" onClick={() => handleStepChange(1)}
                                    disabled={!(zone !== "")}
                                >Continue</button>

                            }
                            {regStep === 4 &&
                                <button className="orange_btn" onClick={createNewPI}>Done</button>
                            }
                        </div>

                    </div>
                </div>

            </div>
            <PopUpModal
                handleClose={handleClosePopup}
                open={open}
                title={"Success!"}
                msg={convertToTitleCase(mrName) + "'s Marketing Head profile has been created!"}
                close={"Close"}
                actionbtn={"Done"}
                onConfirm={viewProfile}
            />
        </div>
        {loading && <Loader />}
        </>
    );
};

export default PMSAdminAddMarketingHead;   